import React from "react";
import { MainContainer } from "../Components/Elements";
import LegacyFinanceNotice from "../Components/LegacyFinanceNotice";

const Finance = () => (
  <MainContainer>
    <LegacyFinanceNotice />
  </MainContainer>
);

export default Finance;
